function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import { Selector, DropDown, ArrowIcon, Menu, MenuItem, Span } from "./styles";
import CheckmarkCircleFill from "../Svg/Icons/CheckmarkCircleFill";
var NetworksSelector = function(_param) {
    var networks = _param.networks, currentNetwork = _param.currentNetwork, setNetwork = _param.setNetwork, props = _objectWithoutProperties(_param, [
        "networks",
        "currentNetwork",
        "setNetwork"
    ]);
    var ref = useState(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = useState(null), targetRef = ref1[0], setTargetRef = ref1[1];
    var ref2 = useState(null), tooltipRef = ref2[0], setTooltipRef = ref2[1];
    var ref3 = usePopper(targetRef, tooltipRef, {
        strategy: "fixed",
        placement: "bottom-end",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        0
                    ]
                }
            }
        ]
    }), styles = ref3.styles, attributes = ref3.attributes;
    var onChangeNetworks = function(network) {
        setIsOpen(false);
        setNetwork(network);
    };
    var onShowDropDown = function(event) {
        setIsOpen(function(prevState) {
            return !prevState;
        });
        event.stopPropagation();
    };
    useEffect(function() {
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ _jsxs(Selector, _objectSpread({
        alignItems: "center",
        height: "100%",
        ref: setTargetRef
    }, props, {
        children: [
            /*#__PURE__*/ _jsxs(DropDown, {
                onClick: onShowDropDown,
                children: [
                    currentNetwork === null || currentNetwork === void 0 ? void 0 : currentNetwork.icon,
                    /*#__PURE__*/ _jsxs(Span, {
                        children: [
                            (currentNetwork === null || currentNetwork === void 0 ? void 0 : currentNetwork.value) || "...",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ArrowIcon, {
                        ml: "7px",
                        show: isOpen
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Menu, _objectSpread({
                style: styles.popper,
                ref: setTooltipRef
            }, attributes.popper, {
                isOpen: isOpen,
                children: networks === null || networks === void 0 ? void 0 : networks.map(function(network) {
                    /*#__PURE__*/ return _jsxs(MenuItem, {
                        disabled: network.disabled,
                        onClick: function() {
                            return onChangeNetworks(network);
                        },
                        children: [
                            network === null || network === void 0 ? void 0 : network.icon,
                            /*#__PURE__*/ _jsx(Span, {
                                children: network.value
                            }),
                            network.name === currentNetwork.name && /*#__PURE__*/ _jsx(CheckmarkCircleFill, {
                                width: "16px",
                                color: "success"
                            })
                        ]
                    }, network.name);
                })
            }))
        ]
    }));
};
export default NetworksSelector;
